export const MAX_DUE_DAYS = 3650;
